import { TemplateResult, LitElement, html } from 'lit';
import { customElement, queryAssignedElements } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import encapsulatedStyles from './styles/outline-subnav-block.encapsulated.pcss?inline';
import globalStyles from './styles/outline-subnav-block.global.pcss?inline';

/**
 * Outline Subnav Block component
 * 
 * @slot - The subnav items
 */

@customElement('outline-subnav-block')
export class OutlineSubnavBlock extends LitElement {

    @queryAssignedElements({slot: 'menu'})
    menuItems: Array<HTMLElement>;
  
    adoptedStyleSheets = new AdoptedStyleSheets(this, {
        encapsulatedCSS: encapsulatedStyles,
        globalCSS: globalStyles,
    });

    firstUpdated() {
        this.setClickeableEntireAnchor();
    }

    setClickeableEntireAnchor = () => {
        this.menuItems[0].addEventListener('click', (e: Event) => {
            const tag = (e.target as HTMLElement).tagName;
            
            if (tag === 'OUTLINE-LINK') {
                const anchor = (e.target as HTMLElement).querySelector('a');
                if (anchor) {
                    anchor.click();
                }
            } else if (tag === 'A') {
                (e.target as HTMLElement).click();
            }
        });
    };

    render(): TemplateResult {
        return html`
        <div class="subnav">
            <div class="subnav-container">
                <slot name="menu"></slot>
            </div>
        </div>
        
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'outline-subnav-block': OutlineSubnavBlock;
    }
}
